import { GHSImages, GHSURL } from './constants';

const formatLabel = (key) => (key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ').replace(/([A-Z])/g, ' $1').trim());
const formatPPEImagePath = (file) => (`/safetynow/ppe/${file}.png`);
const formatExtinguisherImagePath = (file) => (`/safetynow/extinguishers/${file}.png`);

const getGHSImage = (hcode) => {
    for (const [key, value] of Object.entries(GHSImages)) {
        if (value.includes(hcode)) {
            return GHSURL(key);
        }
    }
};

const getAllGHSImages = (hazards) => {
    // const final = {};
    const final = [];

    if (!hazards || hazards.length === 0) {
        return final;
    }

    hazards.forEach(element => {
        const image = getGHSImage(element.code);
        if (image) {
            final.push({ ...element, image });
        } else {
            final.push({ ...element, image: null });
        }
    });

    return final

    // for (const hazard of hazards) {
    //     const image = getGHSImage(hazard.code);
    //     // if (image && !final[image]) {
    //     //     final[image] = { ...hazard, image, statements: [hazard.statement] };
    //     // } else if (image && final[image]) {
    //     //     final[image].statement += ', ' + hazard.statement;
    //     //     final[image].statements.push(hazard.statement);
    //     // }
    // }

    // return Object.values(final);

};

function formatTemperature(val) {
    if (typeof val === 'number') {
        return `${val} °C`;
    }
    return val;
}

export {
    formatLabel,
    formatPPEImagePath,
    formatExtinguisherImagePath,
    getGHSImage,
    getAllGHSImages,
    formatTemperature,
};
